module.exports = __webpack_public_path__ + "img/zf_icon02-dcc1ff.png";